import { faChevronDown } from '@fortawesome/pro-light-svg-icons/faChevronDown';
import { faChevronUp } from '@fortawesome/pro-light-svg-icons/faChevronUp';
import { Box } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { InvoiceTax } from '@spike/invoice-model';
import clsx from 'clsx';
import toPairs from 'lodash/toPairs';
import { FunctionComponent, useState } from 'react';
import { formatAmount } from './utils/OrderUtils';
import ResumeLine from './UI/ResumeLine';

export interface InvoiceResumeTaxesProps {
    taxes?: InvoiceTax;
    loading?: boolean;
    className?: string;
    defaultExpanded?: boolean;
    lineClassName?: string;
    detailClassName?: string;
    descriptionClassName?: string;
    valueClassName?: string;
}

export interface Tax {
    name: string;
    amount: string;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            display: 'flex',
            flexDirection: 'column'
        },
        tax: {
            marginTop: 11,
            marginLeft: 12
        }
    })
);

export const InvoiceResumeTaxes: FunctionComponent<InvoiceResumeTaxesProps> = props => {
    const classes = useStyles(props);

    const [expanded, setExpanded] = useState(props.defaultExpanded ?? false);

    return (
        <Box className={clsx(classes.container, props.className)}>
            <ResumeLine
                description="Taxes"
                value={formatAmount(props.taxes?.amount)}
                icon={Number(props.taxes?.amount ?? 0) > 0 ? (expanded ? faChevronUp : faChevronDown) : undefined}
                onIconClick={() => setExpanded(prev => !prev)}
                loading={props.loading}
                className={props.lineClassName}
                descriptionClassName={props.descriptionClassName}
                valueClassName={props.valueClassName}
            />
            {expanded &&
                toPairs(props.taxes?.detail ?? []).map((tax, index) => (
                    <ResumeLine
                        key={index}
                        description={tax[0]}
                        value={formatAmount(tax[1])}
                        loading={props.loading}
                        className={props.detailClassName ?? classes.tax}
                        descriptionClassName={props.descriptionClassName}
                        valueClassName={props.valueClassName}
                    />
                ))}
        </Box>
    );
};

export default InvoiceResumeTaxes;
